// src/lib/http.js
import axios from "axios";
import { BASE_URL } from "../config/api.js";

const http = axios.create({
  baseURL: BASE_URL,
  timeout: 30000,
  withCredentials: false,
  headers: { "Content-Type": "application/json" },
});

function getToken() {
  try {
    const raw = localStorage.getItem("bb_user");
    if (!raw) return null;
    const u = JSON.parse(raw);
    return u?.token || null;
  } catch {
    return null;
  }
}

const KEY_HEADER = import.meta.env.VITE_API_KEY_HEADER || "x-api-key";
const KEY_VALUE = import.meta.env.VITE_API_KEY_VALUE;

// attach token + api-key
http.interceptors.request.use((config) => {
  const t = getToken();
  if (t) config.headers.Authorization = `Bearer ${t}`;
  if (KEY_VALUE) config.headers[KEY_HEADER] = KEY_VALUE;
  return config;
});

// unwrap + normalize errors
http.interceptors.response.use(
  (res) => {
    if (res.data.paginate == true) {
      const d = res.data;
      if (d && typeof d === "object" && "data" in d) return d;
      return d;
    } else {
      const d = res.data;
      if (d && typeof d === "object" && "data" in d) return d.data;
      return d;
    }

  },
  (err) => {
    const msg =
      err?.response?.data?.message ||
      err?.message ||
      "Something went wrong";
    if (err?.response?.status === 401 && !err?.config?.skipAuthClear) {
      localStorage.removeItem("bb_user");
    }
    return Promise.reject(new Error(msg));
  }
);

export const get = (url, config) => http.get(url, config);
export const post = (url, body, config) => http.post(url, body, config);
export const put = (url, body, config) => http.put(url, body, config);
export const del = (url, config) => http.delete(url, config);

export default http;

/*  // ← अगर API-key सिर्फ register पर चाहिए:
http.interceptors.request.use((config) => {
  const t = getToken();
  if (t) config.headers.Authorization = `Bearer ${t}`;
  if (KEY_VALUE && /registerUserOTP$/.test(config.url)) {
    config.headers[KEY_HEADER] = KEY_VALUE;
  }
  return config;
});
*/
